























import isGranted from '@/auth/isGranted';
import { HasTaskMixin } from '@/mixins';
import { AccountSettings } from '@/types';
import Tooltip from '@/components/Tooltip.vue';
import { setAutoRenew } from '@/account-settings/account-settings';
import accountSettingsRepository from '../account-settings/account-settings-repository';

interface Data {
  accountSettings: AccountSettings|null,
  autoRenew: boolean,
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      accountSettings: null,
      autoRenew: false,
    };
  },
  watch: {
    accountId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    toggle(value: boolean): void {
      this.task = setAutoRenew(this.accountId, value);
      this.task.then(() => {
        this.autoRenew = value;
      });
    },
    determineAutoRenew(): void {
      if (!this.accountSettings) return;
      this.autoRenew = this.accountSettings.autoRenewal;
    },
    load(): void {
      this.task = accountSettingsRepository.find(this.accountId);
      this.task.then((accountSettings: AccountSettings) => {
        this.accountSettings = accountSettings;
        this.determineAutoRenew();
      });
    },
    isGranted,
  },
  created(): void {
    this.load();
  },
  components: {
    Tooltip,
  },
});
